module.exports = __webpack_public_path__ + "media/Loops Keys.5898fc91.wav";